import { render, staticRenderFns } from "./mevtcraftprocprice.vue?vue&type=template&id=06077013&scoped=true&"
import script from "./mevtcraftprocprice.vue?vue&type=script&lang=js&"
export * from "./mevtcraftprocprice.vue?vue&type=script&lang=js&"
import style0 from "./mevtcraftprocprice.vue?vue&type=style&index=0&id=06077013&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06077013",
  null
  
)

export default component.exports